import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginTop: 0,
    width: 200,
  },
});


function NoteInputField (props) {
  
    const { classes } = props;

    return (
              
        <TextField
          id="multiline-flexible"
          label="Enter Note:"
          name="note"
          multiline
          rowsMax="4"
          value= {props.value}
          onChange={props.onChange}
          className={classes.textField}
          margin="normal"
        />
        
    );
  
}

NoteInputField.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NoteInputField);



// WEBPACK FOOTER //
// ./src/components/material-ui/NoteInputField.js